module.exports = __webpack_public_path__ + "static/media/team-sean.fa421a69.jpg";